import {
    AppointmentOverview,
    Title,
    DateTimePicker,
    PersonalDataForm,
    ServiceCenterPicker,
    VehicleDataForm,
  } from '@/components';

  import router from '@/router';

  import validationFlow from '@/validation-flow';

  import {
    mapActions,
    mapGetters,
    mapMutations,
  } from 'vuex';

  export default {
    name: 'step1Maintenance',
    components: {
      [AppointmentOverview.name]: AppointmentOverview,
      [Title.name]: Title,
      [DateTimePicker.name]: DateTimePicker,
      [PersonalDataForm.name]: PersonalDataForm,
      [ServiceCenterPicker.name]: ServiceCenterPicker,
      [VehicleDataForm.name]: VehicleDataForm,
    },
    props: {},
    data: () => ({}),
    computed: {
      ...mapGetters('appointment', {
        customerDataRaw: 'getCustomerDataRaw',
        loadingState: 'getLoadingState',
        isValidAppointment: 'getIsValidAppointment',
        appointmentPostObject: 'getAppointmentPostObject',
      }),
    },
    methods: {
      ...mapActions('appointment', {
        setAppointment: 'SET_APPOINTMENT',
      }),
      ...mapMutations('appointment', {
        setCat: 'SET_CAT',
      }),
      goToPreviousStep() {
        this.$router.push({
          name: 'step3ServiceType',
        });
      },
      confirmAppointment() {
        const personalDataForm = this.$refs.personalDataForm.$refs.form;
        const personalDataFormTitle = this.$refs.personalDataForm.$refs.formPersonalDataTitle;
        const validPersonalDataFormTitle = personalDataFormTitle.isValid();

        const vehicleDataForm = this.$refs.vehicleDataForm.$refs.form;

        Promise.all([
          personalDataForm.validate(),
          vehicleDataForm.validate(),
        ]).then(([isValidPersonalForm, isValidVehicleForm]) => {
          if (isValidPersonalForm && isValidVehicleForm) {
            if (this.isValidAppointment && validPersonalDataFormTitle && !this.loadingState) {
              this.setCat('depot');
              this.setAppointment(this.appointmentPostObject)
                .then(() => {
                  validationFlow.validateStep1Maintenance();
                })
                .catch(() => {
                  router.push({
                    name: 'error',
                  });
                });
            }
          }
        });
      },
    },
  };
